// Vendor
import * as React from 'react';

// Vendor Components
import withStyles, {
  StyleRulesCallback,
  WithStyles
} from 'material-ui/styles/withStyles';

// Types
interface Props {
  className?: string;
}

type EnhancedProps = Props & WithStyles;

const styles: StyleRulesCallback = () => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%'
  }
});

export const CenteredContent: React.SFC<EnhancedProps> = ({
  classes,
  className,
  children
}) => (
  <div className={`${classes.root} ${className ? className : ''}`}>
    {children}
  </div>
);

CenteredContent.displayName = 'CenteredContent';

export default withStyles(styles)<Props>(CenteredContent);



// WEBPACK FOOTER //
// ./src/ui/components/centered-content/centered-content.tsx